import {
  useGetListItems,
  useMutateItem,
  useMutateDeleteItem,
  useUploadValueList,
} from '../../../hooks/entityMethodsHook'

export const useGetCostCodes = (
  queryKey: string,
  projectId: string | undefined,
  queryOptions: any,
  bodyData: any
) => {
  const uri = `projects/${projectId}/cost-codes/search`
  return useGetListItems(queryKey, uri, bodyData)
}

export const useGetAllCostCodes = (
  queryKey: string,
  projectId: string | undefined,
  params?: any
) => {
  const uri = `projects/${projectId}/cost-codes`
  return useGetListItems(queryKey, uri, params)
}

export const useMutateCostCode = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/cost-codes`
  return useMutateItem(queryKey, uri)
}

export const useDeleteCostCode = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/cost-codes`
  return useMutateDeleteItem(queryKey, uri)
}

export const useProcessCostCodes = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/cost-codes/process-cost-codes`
  return useUploadValueList(queryKey, uri)
}

export const useMutateAiParsedCostCodes = (
  queryKey: string,
  projectId: string | undefined
) => {
  const uri = `projects/${projectId}/cost-codes/save-parsed-cost-codes`
  console.log('uri =>', uri)
  return useMutateItem(queryKey, uri)
}
